import React, { useContext } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import ToolPanel from '../toolpanel';
import Canvas from '../canvas';
import DualViewCanvas from '../canvas/DualViewCanvas';
import GalleryCanvas from '../canvas/GalleryCanvas';
import OcclusionProximityCanvas from '../canvas/OcclusionProximityCanvas';
import { AppContext } from '../App';
import { ToolID } from '../shared/common';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    workspaceRoot: {
      height: '100%',
      width: '100%',
      padding: '0',

      display: 'grid',
      gridTemplateColumns: '320px auto',
    },
    workspaceFull: {
      height: `calc(100vh - 56px)`,
      width: '100%',
      gridColumnStart: 1,
      gridColumnEnd: 3,
    },
    workspaceMini: {
      height: `calc(100vh - 62px)`,
    },
    toolpanel: {
      height: `calc(100vh - 62px)`,
    },
  })
);

const kToolWithPanels = [ToolID.Display, ToolID.OrientationAdjustment, ToolID.Gallery];

// background color
const BG_CLR = '#f5f5f5';

const Workspace = () => {
  const classes = useStyles();
  const { currentTool, dualView } = useContext(AppContext);
  const showToolPanel = (tool: ToolID | null) => {
    return kToolWithPanels.includes(tool);
  };

  const isGallery = () => {
    return ToolID.Gallery === currentTool;
  };

  const isOcclusion = () => {
    return ToolID.OcclusionMapping === currentTool;
  };

  const isNormal = () => {
    return !isOcclusion() && !isGallery();
  };

  return (
    <div className={classes.workspaceRoot}>
      <div className={classes.toolpanel} hidden={!showToolPanel(currentTool)}>
        <ToolPanel tool={currentTool}></ToolPanel>
      </div>

      <div className={showToolPanel(currentTool) ? classes.workspaceMini : classes.workspaceFull}>
        {isNormal() && !dualView && <Canvas id="mainCanvas" background={BG_CLR} />}
        {isNormal() && dualView && <DualViewCanvas />}
        {isGallery() && <GalleryCanvas />}
        {isOcclusion() && <OcclusionProximityCanvas background={BG_CLR} />}
      </div>
    </div>
  );
};

export default Workspace;
